import { LitElement, html } from "lit";
import { faSvg, titles } from "../styles";
import { fa } from "../../utils/widgets";
import { faDownload } from "@fortawesome/free-solid-svg-icons/faDownload";

/**
 * Semantics Download docs displays a synthetic summary of you can download semantics metadata.
 * @class Panoramax.components.menus.SemanticsDownload
 * @element pnx-semantics-download
 * @extends [lit.LitElement](https://lit.dev/docs/api/LitElement/)
 * @example
 * ```html
 * <pnx-semantics-download ._t=${viewer._t} />
 * ```
 */
export default class SemanticsDownload extends LitElement {
	static styles = [ titles, faSvg ];

	render() {
		return html`
			<h4>${fa(faDownload)} ${this._t?.pnx.semantics_download_title}</h4>
			<p>${this._t?.pnx.semantics_download_info}</p>
			<pnx-link-button
				href="https://docs.panoramax.fr/federated-catalog/data_export/"
				target="_blank"
				kind="outline"
				style="width: 100%"
			>${this._t?.pnx.semantics_download_cta}</pnx-link-button>
		`;
	}
}

customElements.define("pnx-semantics-download", SemanticsDownload);
